export default class Notifications {
  static error(message, callback = null, title = null) {
    if (process.env.NODE_ENV !== 'prod') {
      console.error(title, message);
      console.log(new Error().stack);
    }
    if (callback) {
      callback();
    }
  }

  static info (message, title) {
    if (process.env.NODE_ENV !== 'prod') {
      console.info(title, message);
      console.log(new Error().stack);
    }
  }

  static success (message, title) {
    if (process.env.NODE_ENV !== 'prod') {
      console.info(title, message);
      console.log(new Error().stack);
    }
  }

  static warning (message, title) {
    if (process.env.NODE_ENV !== 'prod') {
      console.log(title, message);
      console.log(new Error().stack);
    }
  }
};
